// extracted by mini-css-extract-plugin
export default {"footer-item":"footer_footer-item__taVuV","小红书":"footer_小红书__Z0a8P","socials":"footer_socials__4Z1WE","foot-note":"footer_foot-note__pC5dX"};